import AffairCard from './AffairCard';

export default function AffairKanbanColumn({ action, affairs, label, onRequestTransition, stageKey }) {
  return (
    <section className={`affair-kanban-column ${affairs.length ? '' : 'affair-kanban-column--empty'}`} aria-labelledby={`affair-column-${stageKey}`}>
      <header className="affair-kanban-column__header">
        <h2 id={`affair-column-${stageKey}`}>{label}</h2>
        <span>{affairs.length}</span>
      </header>
      <div className="affair-kanban-column__cards">
        {affairs.length > 0
          ? affairs.map((affair) => <AffairCard key={affair.id} affair={affair} action={action} onRequestTransition={onRequestTransition} />)
          : <p className="affair-kanban-column__empty">Aucune affaire</p>}
      </div>
    </section>
  );
}
